// extracted by mini-css-extract-plugin
module.exports = {"vGray1":"#83929c","group":"WalletTransactions_group__2-MbZ","transaction":"WalletTransactions_transaction__1kXhF","date":"WalletTransactions_date__2K5EQ"};